import { Storage } from '../Storage';
import moment from 'moment';
//用两个\n是为了解决拼接div后 富文本解析不成功的问题
export const answerTag = [`<div class='ai-answer-box'>\n\n`, `\n\n</div>`];
export const thinkTag = [`<think>\n`, `\n</think>`];
export const citationTag = [`<citation>`, `</citation>`];
export const fileStatusMap = {
    0: '上传失败',
    1: '上传中',
    2: '上传成功',
    '-1': '已被删除',
    '-2': '文件不存在'
};
export const parseStatusMap = {
    0: '未开始解析',
    1: '解析成功',
    2: '解析中',
    3: '解析失败',
    '-1': '已被删除',
    '-2': '文件不存在'
};
export const parseStatusDic = {
    unstart: 0,
    success: 1,
    ing: 2,
    fail: 3,
    delete: '-1',
    notExist: '-2'
};
export const fileStatusDic = {
    fail: 0,
    ing: 1,
    success: 2,
    delete: '-1',
    notExist: '-2'
};
export const dateMap = {
    1: '今天',
    2: '昨天',
    3: '7天内'
};
export const fileTypeMap = {
    img: 4,
    file: 5,
    video: 2,
    audio: 3,
    link: 6
};
//维护插件图标
export const plugin_json = {
    0: {
        name: '深度思考',
        type: 'icon-a-shendusikao1'
    },
    1: {
        name: '联网搜索',
        type: 'icon-hulianwang'
    }
};
export const pluginMap = {
    deep_think: 'deep_think',
    web_search: 'web_search',
    voice_call: 'voice_call'
};
//默认插件（通用技能）和后端保持相同格式
export const defaultPlugins = [
    {
        code: 0,
        label: '深度思考',
        name: 'deep_think',
        choice: 0
    }
    // {
    //     code: 1,
    //     label: '联网搜索',
    //     name: 'web_search',
    //     choice: 0
    // }
];
export const defaultPlaceholder = '有什么我可以帮你的嘛～';
export const defaultPageTitle = '智教通';
//默认技能
export const defaultSkill = {
    ability_icon: 'icon-tongyong',
    ability_id: -1,
    ability_name: window.location.pathname.includes('mobile') ? '通用' : '通用技能'
};
//全局注册data-theme属性
export const themeMap = {
    1: 'blue',
    2: 'red',
    3: 'green'
};
//发送按钮图片--主题换色
export const sendButtonImg = {
    1: {
        send: require('@/assets/images/mobile/sendBlue.png'),
        disable: require('@/assets/images/mobile/sendGreyBlue.png'),
        loading: require('@/assets/images/mobile/sendLoadingBlue.png')
    },
    2: {
        send: require('@/assets/images/mobile/sendRed.png'),
        disable: require('@/assets/images/mobile/sendGreyRed.png'),
        loading: require('@/assets/images/mobile/sendLoadingRed.png')
    },
    3: {
        send: require('@/assets/images/mobile/sendGreen.png'),
        disable: require('@/assets/images/mobile/sendGreyGreen.png'),
        loading: require('@/assets/images/mobile/sendLoadingGreen.png')
    }
};
//智能体提示背景图
export const agentTipBgImg = {
    1: require('@/assets/images/web/tip_bg_blue.png'),
    2: require('@/assets/images/web/tip_bg_red.png'),
    3: require('@/assets/images/web/tip_bg_green.png')
};
//开启新对话图片
export const newChatImg = {
    1: require('@/assets/images/mobile/new_chat_blue.png'),
    2: require('@/assets/images/mobile/new_chat_red.png'),
    3: require('@/assets/images/mobile/new_chat_green.png')
};
//开启新对话图片--二次优化版
export const addChatImg = {
    1: require('@/assets/images/mobile/add_blue.png'),
    2: require('@/assets/images/mobile/add_red.png'),
    3: require('@/assets/images/mobile/add_green.png')
};
//更多技能图片
export const moreSkillImg = {
    1: require('@/assets/images/mobile/moreBlue.png'),
    2: require('@/assets/images/mobile/moreRed.png'),
    3: require('@/assets/images/mobile/moreGreen.png')
};
export const eventType = {
    msg: 'message', // 流式数据
    msg_end: 'message_end', // 流式数据结束
    node: 'state' // 非流式数据（数据完整，可以直接解析json）
};
export const messageType = {
    answer: 'answer',
    question: 'question'
};
export const contentType = {
    markdown: 'markdown', //markdown格式
    sensitive: 'sensitive', //敏感词
    exception: 'exception', //异常
    text: 'text', //问题或者回答
    deep_think: 'deep_think', // 深度思考
    web_search: 'web_search', // 网页搜索
    retrieval: 'retrieval', //知识库搜索
    annotation: 'annotation', //标注--匹配到标注 后台直接返回
    workflow: 'workflow', //工作流（总进度）
    recommend_course: 'recommend_course', //课程推荐
    ai_evaluation: 'ai_evaluation', //ai评阅
    ai_evaluation_item: 'ai_evaluation_item',
    ai_evaluation_result: 'ai_evaluation_result',
    multimodal_learning: 'multimodal_learning',
    multimodal: 'multimodal',
    card: 'card'
};
export const roleMap = {
    ai: 'assistant',
    local: 'user'
};
export const templateMap = {
    recommend: 'recommend',
    course: '101', //开放课
    exam: '102', //考试
    practise: '105', //作业
    researchresult: '106', //研修成果
    live: '103', //研讨会
    project: '104', //项目
    school: '108', //父母学堂
    audioBook: '107', //听书
    lecturer: 'lecturer',
    activity: '109' //活动
};

export const getAgentFileDirName = () => {
    const tenant_id = Storage.get('tenantId');
    let today = moment().format('YYYYMMDD');
    return `user/agent/${tenant_id}/${today}`;
};

//智能体附件--上传桶名
export const agentFileBucketName = {
    development: {
        oss: 'ttcdw6-file-test',
        oss_audio: 'ttcdw6-audio-test'
    },
    test: {
        oss: 'ttcdw6-file-test',
        oss_audio: 'ttcdw6-audio-test'
    },
    prod: {
        oss: 'ttcdw6-file',
        oss_audio: 'ttcdw6-audio'
    }
}[process.env.REACT_APP_MODE];
//停止按钮图片--主题换色
export const pauseButtonImg = {
    1: require('@/assets/images/web/pause_blue.png'),
    2: require('@/assets/images/web/pause_red.png'),
    3: require('@/assets/images/web/pause_green.png')
};
export const third_json_handler = {
    chatbi: 'chatbi',
    deerflow: 'deerflow',
    aippt: 'aippt',
    ai_evaluation: 'ai_evaluation',
    recommend_course: 'recommend_course',
    file_chat: 'file_chat',
    case_simulation: 'case_simulation',
    multimodal_learning: 'multimodal_learning',
    multimodal: 'multimodal'
};

export const mobileHideHandler = [
    third_json_handler.chatbi,
    third_json_handler.deerflow,
    third_json_handler.aippt,
    third_json_handler.ai_evaluation,
    third_json_handler.multimodal_learning,
    third_json_handler.multimodal
    // third_json_handler.case_simulation
];
export const AIMarks = ['以上内容由AI生成，仅供参考', '内容由AI生成'];

// AIPPT 主题色数据
export const colorOptions = [
    { id: 0, color: '#1890FF', name: '蓝色' },
    { id: 1, color: '#F5222D', name: '红色' },
    { id: 2, color: '#FA8C16', name: '橙色' },
    { id: 3, color: '#FAAD14', name: '黄色' },
    { id: 4, color: '#52C41A', name: '绿色' },
    { id: 5, color: '#13C2C2', name: '青色' },
    { id: 6, color: '#722ED1', name: '紫色' },
    { id: 7, color: '#FF85C0 ', name: '粉色' }
];

// AIPPT 风格选项
export const styleOptions = ['科技风', '商务风', '小清新', '极简风', '中国风', '可爱卡通'];
